export default {
	type: 'object',
	properties: {
		recordId: { type: 'string' },
	},
	required: ['recordId'],
	additionalProperties: false,
}
